import imagePreviewPanel2Template from '../../templates/media/imagePreviewPanel2.hbs';
import $ from 'jquery';
import _ from 'lodash';
import {View} from 'backbone';

export default View.extend({
    template: imagePreviewPanel2Template,
    events: {
        'click #image-preview-close': '_close',
    },
    render(model, renditionsToPreview) {
        this.image = new Image();
        this.image.src = model.get('originalUrl');
        this.$el.empty().html(imagePreviewPanel2Template(renditionsToPreview));

        _.toArray(this.$el.find('.sda-preview-image-container')).forEach(imageContainer => {
            const renditionName = $(imageContainer).data('rendition');
            const rendition = model.getRendition(renditionName);
            if (rendition) {
                this._renderImage.call(this, imageContainer, rendition.toJSON());
            }
        });

        this.delegateEvents();
    },
    _renderImage(imageContainer, rendition) {
        const $imageContainer = $(imageContainer);
        const renditionScale = rendition.scaleWidth / rendition.width;

        $imageContainer.width(rendition.scaleWidth);
        $imageContainer.height(Math.round((rendition.scaleWidth * rendition.height) / rendition.width));
        $imageContainer
            .find('img')
            .attr('src', this.image.src)
            .width(this.image.width * renditionScale)
            .css({
                top: -Math.round(rendition.y * renditionScale),
                left: -Math.round(rendition.x * renditionScale),
            });
    },
    _close() {
        this.$el.empty();
        this.$el.trigger('exit');
    },
});
